import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Pricing from './components/Pricing';
import Features from './components/Features';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      <Pricing />

      {/* What is FH? Section */}
      <section className="py-12 md:py-24 px-4 sm:px-6 lg:px-20 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8 md:mb-16">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 md:mb-6">
              What is FH?
            </h2>
            <p className="text-base md:text-lg text-gray-600 max-w-3xl mx-auto">
              Familial Hypercholesterolemia (FH) is a genetic condition that causes high cholesterol from birth, 
              affecting 1 in 250 people worldwide.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-3 md:gap-4 mb-8 md:mb-12">
            <div className="h-40 md:h-48 lg:h-64 rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/c5739c6246996b7d74c72f304dd536e5.jpg"
                alt="Medical professional examining patient"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="h-40 md:h-48 lg:h-64 rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=diverse%20family%20multiple%20generations%20grandparents%20parents%20children%20together%20happy%20healthy%20lifestyle%20outdoor%20park%20setting%20warm%20natural%20sunlight%20genetic%20health%20hereditary%20wellness%20family%20bonding%20clean%20simple%20background%20joyful%20expressions%20realistic%20photography&width=600&height=800&seq=fh-family-1&orientation=portrait"
                alt="Multi-generational family"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="h-40 md:h-48 lg:h-64 rounded-2xl overflow-hidden col-span-2">
              <img
                src="https://readdy.ai/api/search-image?query=DNA%20double%20helix%20genetic%20code%20molecular%20structure%20scientific%20visualization%20blue%20teal%20color%20scheme%20medical%20genetics%20hereditary%20information%20chromosomes%20gene%20sequence%20modern%20scientific%20illustration%20clean%20background%20detailed%20molecular%20biology%20research%20laboratory%20concept&width=1400&height=600&seq=fh-dna-1&orientation=landscape"
                alt="DNA and genetic structure"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 lg:gap-8">
            <div className="bg-gradient-to-br from-teal-50 to-white p-6 md:p-8 rounded-2xl border border-teal-100">
              <div className="w-12 h-12 md:w-14 md:h-14 bg-teal-500 rounded-xl flex items-center justify-center mb-4 md:mb-6">
                <i className="ri-dna-line text-2xl md:text-3xl text-white"></i>
              </div>
              <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-3 md:mb-4">Genetic Condition</h3>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                FH is inherited, meaning it's passed down through families. If one parent has FH, 
                each child has a 50% chance of inheriting it.
              </p>
            </div>

            <div className="bg-gradient-to-br from-teal-50 to-white p-6 md:p-8 rounded-2xl border border-teal-100">
              <div className="w-12 h-12 md:w-14 md:h-14 bg-teal-500 rounded-xl flex items-center justify-center mb-4 md:mb-6">
                <i className="ri-heart-pulse-line text-2xl md:text-3xl text-white"></i>
              </div>
              <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-3 md:mb-4">High Cholesterol</h3>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                People with FH have extremely high LDL ("bad") cholesterol levels from birth, 
                leading to early heart disease if untreated.
              </p>
            </div>

            <div className="bg-gradient-to-br from-teal-50 to-white p-6 md:p-8 rounded-2xl border border-teal-100">
              <div className="w-12 h-12 md:w-14 md:h-14 bg-teal-500 rounded-xl flex items-center justify-center mb-4 md:mb-6">
                <i className="ri-shield-cross-line text-2xl md:text-3xl text-white"></i>
              </div>
              <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-3 md:mb-4">Treatable</h3>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                With early diagnosis and proper treatment, people with FH can live long, 
                healthy lives and prevent heart disease.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <Features />
      <Footer />
    </div>
  );
}
